import get_router from "./router"

export default () => get_router().currentRoute.value
